jQuery(document).ready(function($){
    const $slider = $('.banner-slider');
    $slider.on('init reInit afterChange', function (event, slick) {
    if (slick.slideCount <= 1) {
        $(this).find('.slick-dots').hide();
    } else {
        $(this).find('.slick-dots').show();
    }
    });

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: true
    });


    $('.cs-menu-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        dots: false,
        responsive: [
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    $('.cs-achivement-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        dots: false,
        responsive: [
            {
            breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
            breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    $('.cs-gallery-news').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        dots: false,
        responsive: [
            {
            breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            }
        ]
    });


    $('.popup-img img').on('click', function () {
      $('.img-popup img').attr('src', $(this).attr('src'));
      $('.img-popup').fadeIn();
    });

    $('.close, .img-popup').on('click', function (e) {
      if (e.target !== $('.img-popup img')[0]) {
        $('.img-popup').fadeOut();
      }
    });
});




// document.addEventListener("DOMContentLoaded", function () {

//     const popup = document.getElementById("myPopup");
//     const closeBtn = document.querySelector(".close-popup");

//     function openPopup() {
//         popup.classList.add("active");
//     }

//     function closePopup() {
//         popup.classList.remove("active");
//     }

//     if (!sessionStorage.getItem("popupShown")) {
//         setTimeout(() => {
//             openPopup();
//             sessionStorage.setItem("popupShown", "true");
//         }, 500);
//     }

//     closeBtn.addEventListener("click", closePopup);

//     popup.addEventListener("click", function (e) {
//         if (e.target === popup) {
//             closePopup();
//         }
//     });

//     document.addEventListener("visibilitychange", function () {

//         if (document.visibilityState === "visible") {
//             setTimeout(() => {
//                 openPopup();
//             }, 300);
//         }
//     });

// });